
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 128 35"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('circle',{attrs:{"cx":"17.5","cy":"17.5","r":"17.5"}}),_c('animate',{attrs:{"attributeName":"opacity","dur":"1s","begin":"0s","repeatCount":"indefinite","keyTimes":"0;0.167;0.5;0.668;1","values":"0.3;1;1;0.3;0.3"}})]),_c('g',[_c('circle',{attrs:{"cx":"110.5","cy":"17.5","r":"17.5"}}),_c('animate',{attrs:{"attributeName":"opacity","dur":"1s","begin":"0s","repeatCount":"indefinite","keyTimes":"0;0.334;0.5;0.835;1","values":"0.3;0.3;1;1;0.3"}})]),_c('g',[_c('circle',{attrs:{"cx":"64","cy":"17.5","r":"17.5"}}),_c('animate',{attrs:{"attributeName":"opacity","dur":"1s","begin":"0s","repeatCount":"indefinite","keyTimes":"0;0.167;0.334;0.668;0.835;1","values":"0.3;0.3;1;1;0.3;0.3"}})])])
          )
        }
      }
    